/* tslint:disable */
/* eslint-disable */
/**
 * Back office API for bank insurance
 * API for back office access to bank insurance
 *
 * The version of the OpenAPI document: 1.8
 * Contact: vlastimil.seliga@partnersbanka.cz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// URLSearchParams not necessarily used
// @ts-ignore

// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction,
    type EndpointOptions, // THIS IS CUSTOM
  } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface ActiveTerminationRequestV1x4
 */
export interface ActiveTerminationRequestV1x4 {
    /**
     * 
     * @type {string}
     * @memberof ActiveTerminationRequestV1x4
     */
    'requestUuid': string;
    /**
     * 
     * @type {TerminationRequestStatus1V1x4}
     * @memberof ActiveTerminationRequestV1x4
     */
    'status': TerminationRequestStatus1V1x4;
    /**
     * 
     * @type {string}
     * @memberof ActiveTerminationRequestV1x4
     */
    'terminationDate': string;
}


/**
 * Amount in ISO currency - direct copy from BankCommon To be replaced by BankCommon\'s once we will be able to use one common in other common. 
 * @export
 * @interface AmountIsoCurrencyV1x4
 */
export interface AmountIsoCurrencyV1x4 {
    /**
     * 
     * @type {number}
     * @memberof AmountIsoCurrencyV1x4
     */
    'value': number;
    /**
     * 
     * @type {string}
     * @memberof AmountIsoCurrencyV1x4
     */
    'currencyCode': string;
}
/**
 * 
 * @export
 * @interface ContractActionsV1
 */
export interface ContractActionsV1 {
    /**
     * 
     * @type {boolean}
     * @memberof ContractActionsV1
     */
    'withdraw': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContractActionsV1
     */
    'terminate': boolean;
}
/**
 * 
 * @export
 * @interface ContractBusinessPartnerV1
 */
export interface ContractBusinessPartnerV1 {
    /**
     * 
     * @type {string}
     * @memberof ContractBusinessPartnerV1
     */
    'businessPartnerId': string;
    /**
     * 
     * @type {string}
     * @memberof ContractBusinessPartnerV1
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface ContractDetailInsuranceV1
 */
export interface ContractDetailInsuranceV1 {
    /**
     * 
     * @type {string}
     * @memberof ContractDetailInsuranceV1
     */
    'insuranceUuid': string;
    /**
     * 
     * @type {InsuranceDetailStatusV1}
     * @memberof ContractDetailInsuranceV1
     */
    'status': InsuranceDetailStatusV1;
    /**
     * ISO 8601 datetime in UTC, until when is it possible to withdraw the insurance
     * @type {string}
     * @memberof ContractDetailInsuranceV1
     */
    'withdrawDate': string;
    /**
     * 
     * @type {ContractValidPeriodV1}
     * @memberof ContractDetailInsuranceV1
     */
    'valid': ContractValidPeriodV1;
    /**
     * 
     * @type {ContractDetailProductV1}
     * @memberof ContractDetailInsuranceV1
     */
    'product': ContractDetailProductV1;
}


/**
 * 
 * @export
 * @interface ContractDetailProductV1
 */
export interface ContractDetailProductV1 {
    /**
     * 
     * @type {string}
     * @memberof ContractDetailProductV1
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ContractDetailProductV1
     */
    'name': string;
    /**
     * 
     * @type {InsuredSubjectTypeV1}
     * @memberof ContractDetailProductV1
     */
    'insuredSubjectType': InsuredSubjectTypeV1;
    /**
     * 
     * @type {ContractProductVariantV1}
     * @memberof ContractDetailProductV1
     */
    'variant': ContractProductVariantV1;
    /**
     * 
     * @type {InsurancePriceV1x4}
     * @memberof ContractDetailProductV1
     */
    'price': InsurancePriceV1x4;
}


/**
 * 
 * @export
 * @interface ContractOwnerNameV1
 */
export interface ContractOwnerNameV1 {
    /**
     * 
     * @type {string}
     * @memberof ContractOwnerNameV1
     */
    'given'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractOwnerNameV1
     */
    'family'?: string;
}
/**
 * 
 * @export
 * @interface ContractOwnerV1
 */
export interface ContractOwnerV1 {
    /**
     * 
     * @type {string}
     * @memberof ContractOwnerV1
     */
    'pidUuid': string;
    /**
     * 
     * @type {ContractOwnerNameV1}
     * @memberof ContractOwnerV1
     */
    'name': ContractOwnerNameV1;
}
/**
 * 
 * @export
 * @interface ContractPaymentAccountV1
 */
export interface ContractPaymentAccountV1 {
    /**
     * 
     * @type {string}
     * @memberof ContractPaymentAccountV1
     */
    'accountUuid': string;
    /**
     * 
     * @type {string}
     * @memberof ContractPaymentAccountV1
     */
    'iban': string;
    /**
     * 
     * @type {string}
     * @memberof ContractPaymentAccountV1
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface ContractProductVariantV1
 */
export interface ContractProductVariantV1 {
    /**
     * 
     * @type {string}
     * @memberof ContractProductVariantV1
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ContractProductVariantV1
     */
    'version': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ContractStatus1V1x4 = {
    ACTIVE: 'ACTIVE',
    WITHDRAWN: 'WITHDRAWN',
    TERMINATED: 'TERMINATED'
} as const;

export type ContractStatus1V1x4 = typeof ContractStatus1V1x4[keyof typeof ContractStatus1V1x4];


/**
 * 
 * @export
 * @enum {string}
 */

export const ContractStatusV1x4 = {
    ACTIVE: 'ACTIVE',
    WITHDRAWN: 'WITHDRAWN',
    TERMINATED: 'TERMINATED'
} as const;

export type ContractStatusV1x4 = typeof ContractStatusV1x4[keyof typeof ContractStatusV1x4];


/**
 * 
 * @export
 * @interface ContractValidPeriodV1
 */
export interface ContractValidPeriodV1 {
    /**
     * ISO 8601 datetime in UTC
     * @type {string}
     * @memberof ContractValidPeriodV1
     */
    'from': string;
    /**
     * Local date of the end of the contract validity period. If the contract is not renewable, this field is not present. 
     * @type {string}
     * @memberof ContractValidPeriodV1
     */
    'till'?: string;
}
/**
 * 
 * @export
 * @interface CreateTerminationRequestBodyV1
 */
export interface CreateTerminationRequestBodyV1 {
    /**
     * 
     * @type {string}
     * @memberof CreateTerminationRequestBodyV1
     */
    'contractUuid': string;
    /**
     * 
     * @type {TerminationReasonV1}
     * @memberof CreateTerminationRequestBodyV1
     */
    'reason': TerminationReasonV1;
}
/**
 * 
 * @export
 * @interface CreateTerminationResponseV1
 */
export interface CreateTerminationResponseV1 {
    /**
     * 
     * @type {string}
     * @memberof CreateTerminationResponseV1
     */
    'requestUuid': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTerminationResponseV1
     */
    'contractUuid': string;
    /**
     * 
     * @type {TerminationRequestStatusV1}
     * @memberof CreateTerminationResponseV1
     */
    'status': TerminationRequestStatusV1;
    /**
     * 
     * @type {string}
     * @memberof CreateTerminationResponseV1
     */
    'terminationDate': string;
}


/**
 * Optional filter criteria. An omitted or empty collection means \"no restriction\" (all insurance types / all contract statuses are returned). 
 * @export
 * @interface InsuranceContractFilterV1
 */
export interface InsuranceContractFilterV1 {
    /**
     * Filter by insurance type. Empty or omitted means all types.
     * @type {Array<InsuranceTypeV1>}
     * @memberof InsuranceContractFilterV1
     */
    'type'?: Array<InsuranceTypeV1>;
    /**
     * Filter by contract status. Empty or omitted means all statuses.
     * @type {Array<ContractStatus1V1x4>}
     * @memberof InsuranceContractFilterV1
     */
    'status'?: Array<ContractStatus1V1x4>;
}
/**
 * A single bank insurance contract. Mirrors TravelInsuranceContractItem with an added `type` discriminator identifying the insurance type. 
 * @export
 * @interface InsuranceContractItemV1
 */
export interface InsuranceContractItemV1 {
    /**
     * 
     * @type {InsuranceTypeV1}
     * @memberof InsuranceContractItemV1
     */
    'type': InsuranceTypeV1;
    /**
     * Contract UUID
     * @type {string}
     * @memberof InsuranceContractItemV1
     */
    'contractUuid': string;
    /**
     * 
     * @type {ContractStatus1V1x4}
     * @memberof InsuranceContractItemV1
     */
    'status': ContractStatus1V1x4;
    /**
     * Contract number from provider
     * @type {string}
     * @memberof InsuranceContractItemV1
     */
    'contractNumber': string;
    /**
     * 
     * @type {InsuranceProductV1x4}
     * @memberof InsuranceContractItemV1
     */
    'product': InsuranceProductV1x4;
    /**
     * 
     * @type {ActiveTerminationRequestV1x4}
     * @memberof InsuranceContractItemV1
     */
    'activeTerminationRequest'?: ActiveTerminationRequestV1x4;
}


/**
 * Field to sort the insurance contract list by.
 * @export
 * @enum {string}
 */

export const InsuranceContractOrderFieldV1 = {
    VALID_FROM: 'VALID_FROM'
} as const;

export type InsuranceContractOrderFieldV1 = typeof InsuranceContractOrderFieldV1[keyof typeof InsuranceContractOrderFieldV1];


/**
 * Sorting criteria. Defaults to VALID_FROM DESC when omitted.
 * @export
 * @interface InsuranceContractOrderV1
 */
export interface InsuranceContractOrderV1 {
    /**
     * 
     * @type {InsuranceContractOrderFieldV1}
     * @memberof InsuranceContractOrderV1
     */
    'name': InsuranceContractOrderFieldV1;
    /**
     * 
     * @type {SortOrderTypeV1x0}
     * @memberof InsuranceContractOrderV1
     */
    'order': SortOrderTypeV1x0;
}


/**
 * Filtering, sorting and pagination criteria for the bank insurance contract list.
 * @export
 * @interface InsuranceContractSearchRequestV1
 */
export interface InsuranceContractSearchRequestV1 {
    /**
     * 
     * @type {InsuranceContractFilterV1}
     * @memberof InsuranceContractSearchRequestV1
     */
    'filter'?: InsuranceContractFilterV1;
    /**
     * 
     * @type {InsuranceContractOrderV1}
     * @memberof InsuranceContractSearchRequestV1
     */
    'order'?: InsuranceContractOrderV1;
    /**
     * 
     * @type {PageableV1x0}
     * @memberof InsuranceContractSearchRequestV1
     */
    'pageable'?: PageableV1x0;
}
/**
 * 
 * @export
 * @interface InsuranceContractSearchResponseV1
 */
export interface InsuranceContractSearchResponseV1 {
    /**
     * 
     * @type {Array<InsuranceContractItemV1>}
     * @memberof InsuranceContractSearchResponseV1
     */
    'contracts': Array<InsuranceContractItemV1>;
    /**
     * 
     * @type {PageableResponseV1x0}
     * @memberof InsuranceContractSearchResponseV1
     */
    'pageable': PageableResponseV1x0;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const InsuranceDetailStatusV1 = {
    ACTIVE: 'ACTIVE',
    WITHDRAWN: 'WITHDRAWN',
    TERMINATED: 'TERMINATED',
    CANCELLED: 'CANCELLED',
    ERROR: 'ERROR'
} as const;

export type InsuranceDetailStatusV1 = typeof InsuranceDetailStatusV1[keyof typeof InsuranceDetailStatusV1];


/**
 * 
 * @export
 * @enum {string}
 */

export const InsurancePeriodV1x4 = {
    MONTHLY: 'MONTHLY',
    QUARTERLY: 'QUARTERLY',
    SEMI_ANNUAL: 'SEMI_ANNUAL',
    ANNUAL: 'ANNUAL'
} as const;

export type InsurancePeriodV1x4 = typeof InsurancePeriodV1x4[keyof typeof InsurancePeriodV1x4];


/**
 * 
 * @export
 * @interface InsurancePriceV1x4
 */
export interface InsurancePriceV1x4 {
    /**
     * 
     * @type {AmountIsoCurrencyV1x4}
     * @memberof InsurancePriceV1x4
     */
    'amount': AmountIsoCurrencyV1x4;
    /**
     * 
     * @type {InsurancePeriodV1x4}
     * @memberof InsurancePriceV1x4
     */
    'period': InsurancePeriodV1x4;
}


/**
 * 
 * @export
 * @interface InsuranceProductV1x4
 */
export interface InsuranceProductV1x4 {
    /**
     * 
     * @type {string}
     * @memberof InsuranceProductV1x4
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof InsuranceProductV1x4
     */
    'name': string;
    /**
     * 
     * @type {InsurancePriceV1x4}
     * @memberof InsuranceProductV1x4
     */
    'price': InsurancePriceV1x4;
}
/**
 * Discriminator of the bank insurance product type.
 * @export
 * @enum {string}
 */

export const InsuranceTypeV1 = {
    TRAVEL: 'TRAVEL'
} as const;

export type InsuranceTypeV1 = typeof InsuranceTypeV1[keyof typeof InsuranceTypeV1];


/**
 * 
 * @export
 * @enum {string}
 */

export const InsuredSubjectTypeV1 = {
    INDIVIDUAL: 'INDIVIDUAL',
    FAMILY: 'FAMILY'
} as const;

export type InsuredSubjectTypeV1 = typeof InsuredSubjectTypeV1[keyof typeof InsuredSubjectTypeV1];


/**
 * Pagaeble object used for searching. Returns the state of pagination.
 * @export
 * @interface PageableResponseV1x0
 */
export interface PageableResponseV1x0 {
    /**
     * Number of the page.
     * @type {number}
     * @memberof PageableResponseV1x0
     */
    'pageNumber': number;
    /**
     * Number of records per page.
     * @type {number}
     * @memberof PageableResponseV1x0
     */
    'pageSize': number;
    /**
     * Total number of pages with this page size.
     * @type {number}
     * @memberof PageableResponseV1x0
     */
    'totalPages': number;
    /**
     * Total size of all records.
     * @type {number}
     * @memberof PageableResponseV1x0
     */
    'totalSize': number;
}
/**
 * Object for search paging.
 * @export
 * @interface PageableV1x0
 */
export interface PageableV1x0 {
    /**
     * Number of the page.
     * @type {number}
     * @memberof PageableV1x0
     */
    'pageNumber': number;
    /**
     * Maximum number of records per page.
     * @type {number}
     * @memberof PageableV1x0
     */
    'pageSize': number;
}
/**
 * Sorting order - ascendent or descendent.
 * @export
 * @enum {string}
 */

export const SortOrderTypeV1x0 = {
    ASC: 'ASC',
    DESC: 'DESC'
} as const;

export type SortOrderTypeV1x0 = typeof SortOrderTypeV1x0[keyof typeof SortOrderTypeV1x0];


/**
 * 
 * @export
 * @enum {string}
 */

export const TerminationReasonCodeV1 = {
    BANK_REQUEST: 'BANK_REQUEST',
    CLIENT_REQUEST: 'CLIENT_REQUEST',
    STATUTORY_PERIOD: 'STATUTORY_PERIOD',
    OTHER: 'OTHER'
} as const;

export type TerminationReasonCodeV1 = typeof TerminationReasonCodeV1[keyof typeof TerminationReasonCodeV1];


/**
 * 
 * @export
 * @interface TerminationReasonV1
 */
export interface TerminationReasonV1 {
    /**
     * 
     * @type {TerminationReasonCodeV1}
     * @memberof TerminationReasonV1
     */
    'code': TerminationReasonCodeV1;
    /**
     * Optional free-text reason for termination
     * @type {string}
     * @memberof TerminationReasonV1
     */
    'text'?: string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const TerminationRequestStatus1V1x4 = {
    PENDING: 'PENDING',
    PROCESSED: 'PROCESSED'
} as const;

export type TerminationRequestStatus1V1x4 = typeof TerminationRequestStatus1V1x4[keyof typeof TerminationRequestStatus1V1x4];


/**
 * 
 * @export
 * @enum {string}
 */

export const TerminationRequestStatusV1 = {
    APPROVED: 'APPROVED',
    PROCESSED: 'PROCESSED',
    CANCELLED: 'CANCELLED'
} as const;

export type TerminationRequestStatusV1 = typeof TerminationRequestStatusV1[keyof typeof TerminationRequestStatusV1];


/**
 * 
 * @export
 * @interface TravelInsuranceContractDetailResponseV1
 */
export interface TravelInsuranceContractDetailResponseV1 {
    /**
     * Contract UUID
     * @type {string}
     * @memberof TravelInsuranceContractDetailResponseV1
     */
    'contractUuid': string;
    /**
     * Contract number from provider
     * @type {string}
     * @memberof TravelInsuranceContractDetailResponseV1
     */
    'contractNumber': string;
    /**
     * 
     * @type {ContractValidPeriodV1}
     * @memberof TravelInsuranceContractDetailResponseV1
     */
    'valid': ContractValidPeriodV1;
    /**
     * Minimum period for which the insurance cannot be terminated early. ISO 8601 duration.
     * @type {string}
     * @memberof TravelInsuranceContractDetailResponseV1
     */
    'minimumValidityPeriod': string;
    /**
     * 
     * @type {ContractBusinessPartnerV1}
     * @memberof TravelInsuranceContractDetailResponseV1
     */
    'businessPartner': ContractBusinessPartnerV1;
    /**
     * 
     * @type {ContractStatusV1x4}
     * @memberof TravelInsuranceContractDetailResponseV1
     */
    'status': ContractStatusV1x4;
    /**
     * 
     * @type {ContractDetailInsuranceV1}
     * @memberof TravelInsuranceContractDetailResponseV1
     */
    'insurance': ContractDetailInsuranceV1;
    /**
     * 
     * @type {ContractPaymentAccountV1}
     * @memberof TravelInsuranceContractDetailResponseV1
     */
    'paymentAccount': ContractPaymentAccountV1;
    /**
     * 
     * @type {ContractOwnerV1}
     * @memberof TravelInsuranceContractDetailResponseV1
     */
    'owner': ContractOwnerV1;
    /**
     * 
     * @type {ContractActionsV1}
     * @memberof TravelInsuranceContractDetailResponseV1
     */
    'actions': ContractActionsV1;
    /**
     * 
     * @type {ActiveTerminationRequestV1x4}
     * @memberof TravelInsuranceContractDetailResponseV1
     */
    'activeTerminationRequest'?: ActiveTerminationRequestV1x4;
}


/**
 * 
 * @export
 * @interface TravelInsuranceContractItemV1
 */
export interface TravelInsuranceContractItemV1 {
    /**
     * Contract UUID
     * @type {string}
     * @memberof TravelInsuranceContractItemV1
     */
    'contractUuid': string;
    /**
     * 
     * @type {ContractStatus1V1x4}
     * @memberof TravelInsuranceContractItemV1
     */
    'status': ContractStatus1V1x4;
    /**
     * Contract number from provider
     * @type {string}
     * @memberof TravelInsuranceContractItemV1
     */
    'contractNumber': string;
    /**
     * 
     * @type {InsuranceProductV1x4}
     * @memberof TravelInsuranceContractItemV1
     */
    'product': InsuranceProductV1x4;
    /**
     * 
     * @type {ActiveTerminationRequestV1x4}
     * @memberof TravelInsuranceContractItemV1
     */
    'activeTerminationRequest'?: ActiveTerminationRequestV1x4;
}


/**
 * 
 * @export
 * @interface UserContractListResponseV1
 */
export interface UserContractListResponseV1 {
    /**
     * 
     * @type {TravelInsuranceContractItemV1}
     * @memberof UserContractListResponseV1
     */
    'travelInsuranceContract'?: TravelInsuranceContractItemV1;
}


/**
 * BankTravelInsuranceBackOfficeApi - axios parameter creator
 * @export
 */
export const BankTravelInsuranceBackOfficeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get list of all insurance contract details for back office purposes for an user
         * @param {string} clientUuid 
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allBankInsuranceContractsV1: async (clientUuid: string, xCorrelationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientUuid' is not null or undefined
            assertParamExists('allBankInsuranceContractsV1', 'clientUuid', clientUuid)
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('allBankInsuranceContractsV1', 'xCorrelationId', xCorrelationId)
            const localVarPath = `/coop-bank-insurance-backoffice/v1/clients/{clientUuid}/insurance-contracts`
                .replace(`{${"clientUuid"}}`, encodeURIComponent(String(clientUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get details of a bank travel insurance contract
         * @param {string} clientUuid 
         * @param {string} contractUuid 
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bankTravelInsuranceContractDetailsV1: async (clientUuid: string, contractUuid: string, xCorrelationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientUuid' is not null or undefined
            assertParamExists('bankTravelInsuranceContractDetailsV1', 'clientUuid', clientUuid)
            // verify required parameter 'contractUuid' is not null or undefined
            assertParamExists('bankTravelInsuranceContractDetailsV1', 'contractUuid', contractUuid)
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('bankTravelInsuranceContractDetailsV1', 'xCorrelationId', xCorrelationId)
            const localVarPath = `/coop-bank-insurance-backoffice/v1/clients/{clientUuid}/travel-insurance-contracts/{contractUuid}`
                .replace(`{${"clientUuid"}}`, encodeURIComponent(String(clientUuid)))
                .replace(`{${"contractUuid"}}`, encodeURIComponent(String(contractUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a termination request for an existing insurance contract from back office
         * @param {string} clientUuid 
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {CreateTerminationRequestBodyV1} createTerminationRequestBodyV1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTerminationRequestV1: async (clientUuid: string, xCorrelationId: string, createTerminationRequestBodyV1: CreateTerminationRequestBodyV1, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientUuid' is not null or undefined
            assertParamExists('createTerminationRequestV1', 'clientUuid', clientUuid)
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('createTerminationRequestV1', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'createTerminationRequestBodyV1' is not null or undefined
            assertParamExists('createTerminationRequestV1', 'createTerminationRequestBodyV1', createTerminationRequestBodyV1)
            const localVarPath = `/coop-bank-insurance-backoffice/v1/clients/{clientUuid}/coop-bank-insurance-travel/termination-requests`
                .replace(`{${"clientUuid"}}`, encodeURIComponent(String(clientUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTerminationRequestBodyV1, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a filtered, sorted and paginated list of all bank insurance contracts the client has ever held (including historical ones), for back office purposes. 
         * @param {string} clientUuid 
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {InsuranceContractSearchRequestV1} insuranceContractSearchRequestV1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchBankInsuranceContractsV1: async (clientUuid: string, xCorrelationId: string, insuranceContractSearchRequestV1: InsuranceContractSearchRequestV1, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientUuid' is not null or undefined
            assertParamExists('searchBankInsuranceContractsV1', 'clientUuid', clientUuid)
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('searchBankInsuranceContractsV1', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'insuranceContractSearchRequestV1' is not null or undefined
            assertParamExists('searchBankInsuranceContractsV1', 'insuranceContractSearchRequestV1', insuranceContractSearchRequestV1)
            const localVarPath = `/coop-bank-insurance-backoffice/v1/clients/{clientUuid}/insurance-contracts`
                .replace(`{${"clientUuid"}}`, encodeURIComponent(String(clientUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(insuranceContractSearchRequestV1, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BankTravelInsuranceBackOfficeApi - functional programming interface
 * @export
 */
export const BankTravelInsuranceBackOfficeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BankTravelInsuranceBackOfficeApiAxiosParamCreator(configuration)
    return {
        /**
         * Get list of all insurance contract details for back office purposes for an user
         * @param {string} clientUuid 
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allBankInsuranceContractsV1(clientUuid: string, xCorrelationId: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserContractListResponseV1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allBankInsuranceContractsV1(clientUuid, xCorrelationId, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get details of a bank travel insurance contract
         * @param {string} clientUuid 
         * @param {string} contractUuid 
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bankTravelInsuranceContractDetailsV1(clientUuid: string, contractUuid: string, xCorrelationId: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TravelInsuranceContractDetailResponseV1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bankTravelInsuranceContractDetailsV1(clientUuid, contractUuid, xCorrelationId, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create a termination request for an existing insurance contract from back office
         * @param {string} clientUuid 
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {CreateTerminationRequestBodyV1} createTerminationRequestBodyV1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTerminationRequestV1(clientUuid: string, xCorrelationId: string, createTerminationRequestBodyV1: CreateTerminationRequestBodyV1, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateTerminationResponseV1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTerminationRequestV1(clientUuid, xCorrelationId, createTerminationRequestBodyV1, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a filtered, sorted and paginated list of all bank insurance contracts the client has ever held (including historical ones), for back office purposes. 
         * @param {string} clientUuid 
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {InsuranceContractSearchRequestV1} insuranceContractSearchRequestV1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchBankInsuranceContractsV1(clientUuid: string, xCorrelationId: string, insuranceContractSearchRequestV1: InsuranceContractSearchRequestV1, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InsuranceContractSearchResponseV1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchBankInsuranceContractsV1(clientUuid, xCorrelationId, insuranceContractSearchRequestV1, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BankTravelInsuranceBackOfficeApi - factory interface
 * @export
 */
export const BankTravelInsuranceBackOfficeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BankTravelInsuranceBackOfficeApiFp(configuration)
    return {
        /**
         * Get list of all insurance contract details for back office purposes for an user
         * @param {BankTravelInsuranceBackOfficeApiAllBankInsuranceContractsV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allBankInsuranceContractsV1(requestParameters: BankTravelInsuranceBackOfficeApiAllBankInsuranceContractsV1Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<UserContractListResponseV1> {
            return localVarFp.allBankInsuranceContractsV1(requestParameters.clientUuid, requestParameters.xCorrelationId, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Get details of a bank travel insurance contract
         * @param {BankTravelInsuranceBackOfficeApiBankTravelInsuranceContractDetailsV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bankTravelInsuranceContractDetailsV1(requestParameters: BankTravelInsuranceBackOfficeApiBankTravelInsuranceContractDetailsV1Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<TravelInsuranceContractDetailResponseV1> {
            return localVarFp.bankTravelInsuranceContractDetailsV1(requestParameters.clientUuid, requestParameters.contractUuid, requestParameters.xCorrelationId, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Create a termination request for an existing insurance contract from back office
         * @param {BankTravelInsuranceBackOfficeApiCreateTerminationRequestV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTerminationRequestV1(requestParameters: BankTravelInsuranceBackOfficeApiCreateTerminationRequestV1Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<CreateTerminationResponseV1> {
            return localVarFp.createTerminationRequestV1(requestParameters.clientUuid, requestParameters.xCorrelationId, requestParameters.createTerminationRequestBodyV1, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Get a filtered, sorted and paginated list of all bank insurance contracts the client has ever held (including historical ones), for back office purposes. 
         * @param {BankTravelInsuranceBackOfficeApiSearchBankInsuranceContractsV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchBankInsuranceContractsV1(requestParameters: BankTravelInsuranceBackOfficeApiSearchBankInsuranceContractsV1Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<InsuranceContractSearchResponseV1> {
            return localVarFp.searchBankInsuranceContractsV1(requestParameters.clientUuid, requestParameters.xCorrelationId, requestParameters.insuranceContractSearchRequestV1, options, endpointOptions).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for allBankInsuranceContractsV1 operation in BankTravelInsuranceBackOfficeApi.
 * @export
 * @type BankTravelInsuranceBackOfficeApiAllBankInsuranceContractsV1Request
 */
export type BankTravelInsuranceBackOfficeApiAllBankInsuranceContractsV1Request = {
    /**
     * 
     * @type {string}
     * @memberof BankTravelInsuranceBackOfficeApiAllBankInsuranceContractsV1
     */
    readonly clientUuid: string

    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof BankTravelInsuranceBackOfficeApiAllBankInsuranceContractsV1
     */
    readonly xCorrelationId: string
}

/**
 * Request parameters for bankTravelInsuranceContractDetailsV1 operation in BankTravelInsuranceBackOfficeApi.
 * @export
 * @type BankTravelInsuranceBackOfficeApiBankTravelInsuranceContractDetailsV1Request
 */
export type BankTravelInsuranceBackOfficeApiBankTravelInsuranceContractDetailsV1Request = {
    /**
     * 
     * @type {string}
     * @memberof BankTravelInsuranceBackOfficeApiBankTravelInsuranceContractDetailsV1
     */
    readonly clientUuid: string

    /**
     * 
     * @type {string}
     * @memberof BankTravelInsuranceBackOfficeApiBankTravelInsuranceContractDetailsV1
     */
    readonly contractUuid: string

    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof BankTravelInsuranceBackOfficeApiBankTravelInsuranceContractDetailsV1
     */
    readonly xCorrelationId: string
}

/**
 * Request parameters for createTerminationRequestV1 operation in BankTravelInsuranceBackOfficeApi.
 * @export
 * @type BankTravelInsuranceBackOfficeApiCreateTerminationRequestV1Request
 */
export type BankTravelInsuranceBackOfficeApiCreateTerminationRequestV1Request = {
    /**
     * 
     * @type {string}
     * @memberof BankTravelInsuranceBackOfficeApiCreateTerminationRequestV1
     */
    readonly clientUuid: string

    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof BankTravelInsuranceBackOfficeApiCreateTerminationRequestV1
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {CreateTerminationRequestBodyV1}
     * @memberof BankTravelInsuranceBackOfficeApiCreateTerminationRequestV1
     */
    readonly createTerminationRequestBodyV1: CreateTerminationRequestBodyV1
}

/**
 * Request parameters for searchBankInsuranceContractsV1 operation in BankTravelInsuranceBackOfficeApi.
 * @export
 * @type BankTravelInsuranceBackOfficeApiSearchBankInsuranceContractsV1Request
 */
export type BankTravelInsuranceBackOfficeApiSearchBankInsuranceContractsV1Request = {
    /**
     * 
     * @type {string}
     * @memberof BankTravelInsuranceBackOfficeApiSearchBankInsuranceContractsV1
     */
    readonly clientUuid: string

    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof BankTravelInsuranceBackOfficeApiSearchBankInsuranceContractsV1
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {InsuranceContractSearchRequestV1}
     * @memberof BankTravelInsuranceBackOfficeApiSearchBankInsuranceContractsV1
     */
    readonly insuranceContractSearchRequestV1: InsuranceContractSearchRequestV1
}

/**
 * BankTravelInsuranceBackOfficeApi - object-oriented interface
 * @export
 * @class BankTravelInsuranceBackOfficeApi
 * @extends {BaseAPI}
 */
export class BankTravelInsuranceBackOfficeApi extends BaseAPI {
    /**
     * Get list of all insurance contract details for back office purposes for an user
     * @param {BankTravelInsuranceBackOfficeApiAllBankInsuranceContractsV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankTravelInsuranceBackOfficeApi
     */
    public allBankInsuranceContractsV1(requestParameters: BankTravelInsuranceBackOfficeApiAllBankInsuranceContractsV1Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return BankTravelInsuranceBackOfficeApiFp(this.configuration).allBankInsuranceContractsV1(requestParameters.clientUuid, requestParameters.xCorrelationId, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get details of a bank travel insurance contract
     * @param {BankTravelInsuranceBackOfficeApiBankTravelInsuranceContractDetailsV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankTravelInsuranceBackOfficeApi
     */
    public bankTravelInsuranceContractDetailsV1(requestParameters: BankTravelInsuranceBackOfficeApiBankTravelInsuranceContractDetailsV1Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return BankTravelInsuranceBackOfficeApiFp(this.configuration).bankTravelInsuranceContractDetailsV1(requestParameters.clientUuid, requestParameters.contractUuid, requestParameters.xCorrelationId, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a termination request for an existing insurance contract from back office
     * @param {BankTravelInsuranceBackOfficeApiCreateTerminationRequestV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankTravelInsuranceBackOfficeApi
     */
    public createTerminationRequestV1(requestParameters: BankTravelInsuranceBackOfficeApiCreateTerminationRequestV1Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return BankTravelInsuranceBackOfficeApiFp(this.configuration).createTerminationRequestV1(requestParameters.clientUuid, requestParameters.xCorrelationId, requestParameters.createTerminationRequestBodyV1, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a filtered, sorted and paginated list of all bank insurance contracts the client has ever held (including historical ones), for back office purposes. 
     * @param {BankTravelInsuranceBackOfficeApiSearchBankInsuranceContractsV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankTravelInsuranceBackOfficeApi
     */
    public searchBankInsuranceContractsV1(requestParameters: BankTravelInsuranceBackOfficeApiSearchBankInsuranceContractsV1Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return BankTravelInsuranceBackOfficeApiFp(this.configuration).searchBankInsuranceContractsV1(requestParameters.clientUuid, requestParameters.xCorrelationId, requestParameters.insuranceContractSearchRequestV1, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }
}


